<p-confirmDialog key="addaccount" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="InstructionDiv">
	<h4 style="text-align: center">Instructions:</h4>
	<p style="font-size: 12px">
		This popup creates an account for a substititue.
		<br />
		<br />
		Enter the sub's name, username, and email and they will receive an email with their username and password.
		<br />
		Their account will have access to level 6 instructor permissions (so they can use the class attendance page.)
		<br />
		<br />
		Use the Edit Assignments popup to add which teachers a sub or normal staff member is subbing in for.
	</p>
</div>

<!--Main Grid-->
<div class="MainGrid2Col">
	<label>School:</label>
	<label class="InfoText">{{ SchoolNumber }} - {{ SchoolName }}</label>

	<!--INSERT CUSTOM POPUP FIELDS-->
	<label>First Name:</label>
	<input class="form-control" type="text" placeholder="Sub's First Name" [(ngModel)]="FirstName" (ngModelChange)="onFirstNameChange($event)" />

	<label>Last Name:</label>
	<input class="form-control" type="text" placeholder="Sub's Last Name" [(ngModel)]="LastName" (ngModelChange)="onLastNameChange($event)" />

	<label>Username:</label>
	<input class="form-control" type="text" placeholder="Username for sub account" [(ngModel)]="UserName" />

	<label style="margin: 0px">Select Email Domain:</label>

	<div class="RadioFlex">
		<input id="Dropdown" value="Dropdown" [(ngModel)]="DomainSelect" (ngModelChange)="onRadioChange($event)" name="DomainSelect" type="radio" />
		<label for="Dropdown" class="FlexItem">From Dropdown</label>

		<input
			id="Manual"
			value="Manual"
			[(ngModel)]="DomainSelect"
			(ngModelChange)="onRadioChange($event)"
			style="margin-left: 20px"
			name="DomainSelect"
			type="radio"
		/>
		<label for="Manual" class="FlexItem">Enter Manually</label>
	</div>

	<label>Sub's Email:</label>
	<div style="display: flex; align-items: center">
		<input *ngIf="DomainSelect == 'Dropdown'" placeholder="Enter Email" class="form-control" type="text" [(ngModel)]="Email" />
		<input *ngIf="DomainSelect == 'Manual'" placeholder="Sub's Email abc123@access411.com" class="form-control" type="text" [(ngModel)]="Email" />

		<label *ngIf="DomainSelect == 'Dropdown'" class="FlexItem">&#64;</label>

		<select *ngIf="DomainSelect == 'Dropdown'" class="FlexItem form-control" name="EmailProvider" [(ngModel)]="EmailProvider">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstEmail" [ngValue]="o">
				{{ o.EmailProviderEmailInfo }}
			</option>
		</select>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Create Substitute Account</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
